"use strict";
/**
 * Created by Mavin on 26.04.2017
 */
exports.__esModule = true;
exports.showModal = exports.hideModal = void 0;
var actionTypes_1 = require("./actionTypes");
var hideModal = function () { return ({
    type: actionTypes_1.HIDE_MODAL
}); };
exports.hideModal = hideModal;
var showModal = function (name) { return ({
    type: actionTypes_1.SHOW_MODAL,
    name: name
}); };
exports.showModal = showModal;
